<template>
	<tr>
		<td>
			<div class="number">{{ number }}</div>
		</td>
		<td class="face-cell">
			<span v-bind:class="getClass(1)" v-on:click="setFace(1)"></span>
		</td>
		<td class="face-cell">
			<span v-bind:class="getClass(2)" v-on:click="setFace(2)"></span>
		</td>
		<td class="face-cell">
			<span v-bind:class="getClass(3)" v-on:click="setFace(3)"></span>
		</td>
		<td class="face-cell">
			<span v-bind:class="getClass(4)" v-on:click="setFace(4)"></span>
		</td>
		<td class="face-cell">
			<span v-bind:class="getClass(5)" v-on:click="setFace(5)"></span>
		</td>
		<td>
			<div :class="noAnswerClass">{{ question }}</div>
		</td>
	</tr>
</template>
<script>
	export default {
		name: 'FacesQuestion',
		componentName: 'faces-question',
		props: [
		    'currentPage',
			'number',
			'question',
			'answer',
            'code',
		],
		data(){
			return{
                showNotAnswer:false,
                face: null
			}
		},
        watch:{
		    answer(newVal,oldVal){
                this.face = this.answer;
            }
        },
        computed:{
		    routes(){
		        return {
                    store : this.$root.$refs.page.routes.store,
                    update : this.$root.$refs.page.routes.update
                }
            },
            noAnswerClass(){
		        return this.showNotAnswer && this.face===null ? 'description noAnswer' : 'description';
            }
        },
		methods: {
			getClass: function(value){
				var classes = {
					'face' : true,
					'active': this.face == value					
				};
				
				classes['face-' + value] = true;
				
				return classes;
			},
			setFace: function(face){
			    let update = this.face!==null;
				this.face = face;
				//this.answer = face; // wrong
				this.$emit('interface', this.face );
				this.saveAnswer(update);
			},
            saveAnswer(update){
			    let callSetting = {
			        method: "post",
                    route: this.routes.store,
                }
                if(update){
                    callSetting.method = "put";
                    callSetting.route = this.routes.update;
                }
                axios({
                    method: callSetting.method,
                    url: callSetting.route,
                    data: {
                        question: this.code,
                        answer: this.face,
                        last_page: this.currentPage
                    }
                }).then((response)=>{
                    update
                        ? prolitEvents.$emit('QuestionUpdated')
                        : prolitEvents.$emit('QuestionAnswered');
                }).catch(e=>console.log(e));
            }
		},
		mounted: function(){
			this.face = this.answer;
            prolitEvents.$on('ShowNotAnswered',ev=>{
                this.showNotAnswer=true;
            });
        }
	}
</script>
<style>
    .description.noAnswer{
        color: #ee3126;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/interests/FacesQuestion.vue